import {
  UPDATE_PROJECT_BUDGET_SUCCESS,
  UPDATE_PROJECT_BUDGET_FAIL,
  GET_PROJECT_BUDGET_SUCCESS,
  GET_PROJECT_BUDGET_FAIL,
} from "../actionTypes";

const initialState = { user: null };

const updateProjectBudgetReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROJECT_BUDGET_SUCCESS:
    case GET_PROJECT_BUDGET_SUCCESS:
      return { ...state, user: action.payload.user };
    case UPDATE_PROJECT_BUDGET_FAIL:
    case GET_PROJECT_BUDGET_FAIL:
      return { ...state, user: null };
    default:
      return state;
  }
};

export default updateProjectBudgetReducer;
